var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinesHelpdesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.017 34.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#0081c6;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.018 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.651,20.215l-2.337,2.924a24.685,24.685,0,0,1-8.767-8.767l2.924-2.337a1.986,1.986,0,0,0,.574-2.357l-2.663-6A1.986,1.986,0,0,0,7.067,2.565L1.992,3.889A1.986,1.986,0,0,0,.518,6.1,29.458,29.458,0,0,0,25.6,31.164a1.986,1.986,0,0,0,2.207-1.474l1.324-5.075A1.986,1.986,0,0,0,28.014,22.3l-6.006-2.659a1.986,1.986,0,0,0-2.357.571Z",
    transform: "translate(-0.498 0.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.5,4a7.723,7.723,0,0,1,7.723,7.723",
    transform: "translate(9.157 2.621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.5,1A14.343,14.343,0,0,1,22.843,15.343",
    transform: "translate(9.157 -1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinesHelpdesk);
export default __webpack_public_path__ + "static/media/Icon_Lines_Helpdesk.298d74f6867c5b4f61e19bf1fc70dbb3.svg";
export { ForwardRef as ReactComponent };